export default {
  apiKey: "AIzaSyCJm114AIydyU4wP3DVwCxT5swASfPwXJs",
  authDomain: "ft-clients-files.firebaseapp.com",
  databaseURL: "https://ft-clients-files.firebaseio.com",
  projectId: "ft-clients-files",
  storageBucket: "ft-clients-files.appspot.com",
  messagingSenderId: "397099636188"
}

//
